import { CloakService } from "../services/cloakService";
import { LocaleService } from "../services/localeService";
import { MessageService } from "../services/messageService";
import { DomUtils } from "../utils/domUtils";
import { PhoneMask } from "../components/phoneMask";

export const DefaultRecaptchaReadyWaitTimeout = 5000;

export class BaseController {
	constructor() {
		this._messageService = new MessageService();
		this._localeService = new LocaleService();

		this._recaptchaSiteKey = null;
		this._recaptchaReadyWaitTimeout = DefaultRecaptchaReadyWaitTimeout;
	}

	_ShowMessage(message) {
		this._messageService.ShowMessage(message);
	}

	_FocusElement(elementId) {
		DomUtils.FocusElement(elementId);
	}

	_ValidateElement(elementId) {
		const element = DomUtils.GetElement(elementId);
		return element.validate();
	}

	_SetupPhoneMask(input, domainPhoneMask) {
		const codeFlowTextElement = DomUtils.GetElement(input);
		PhoneMask.Init(codeFlowTextElement, domainPhoneMask);
	}

	_SubmitForm(formId) {
		CloakService.Block();

		setTimeout(() => {
			const formElement = DomUtils.GetElement(formId);
			formElement.submit();
		}, 100);
	}

	_GetRecaptchaToken() {
		const recaptchaKey = this._recaptchaSiteKey;

		return new Promise((resolve, reject) => {
			if (recaptchaKey != null && recaptchaKey !== "") {
				if (window.grecaptcha == null) {
					reject();
					return;
				}

				try {
					// Safeguard - if the recaptcha is not ready, we will wait for it to be ready
					// with a timeout of 5 seconds
					const timeout = setTimeout(() => {
						reject();
					}, this._recaptchaReadyWaitTimeout);

					window.grecaptcha.ready(function () {
						try {
							window.grecaptcha
								.execute(recaptchaKey, { action: "submit" })
								.then(function (token) {
									resolve(token);
								})
								.catch(function (error) {
									reject();
								});
						}
						catch {
							reject();
						}
						finally {
							clearTimeout(timeout);
						}
					});
				}
				catch {
					reject();
				}
			}
			else {
				resolve(null);
			}
		});
	}
}
